import { Link } from "react-router-dom";

export function Logo({ light = false }: { light?: boolean }) {
  return (
    <Link to="/" className="flex items-center gap-2.5 group">
      <img
        src="/moveload-icon.svg"
        alt="Moveload — Smart Transport Platform"
        className="h-9 w-9 rounded-xl shadow-card transition-transform duration-300 group-hover:-rotate-6 group-hover:scale-105"
        width="36"
        height="36"
      />
      <span className={`font-display font-extrabold text-xl tracking-tighter ${light ? "text-primary-foreground" : "text-foreground"}`}>
        Move<span className="text-accent">load</span>
      </span>
    </Link>
  );
}
